var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.619 0.911757C15.9558 1.37065 15.2214 1.72164 14.4442 1.95119C13.5897 0.987532 12.2127 0.649599 10.9962 1.10501C9.77977 1.56041 8.98254 2.71228 9 3.98929V4.66865C6.52773 4.73153 4.18755 3.57621 2.76623 1.59112C2.76623 1.59112 -0.00433025 7.70542 6.22944 10.4229C4.80296 11.3726 3.10366 11.8488 1.38095 11.7816C7.61472 15.1785 15.2338 11.7816 15.2338 3.96891C15.2331 3.77967 15.2146 3.5909 15.1784 3.40503C15.8853 2.72125 16.3841 1.85792 16.619 0.911757Z",
    stroke: "#7D86A1",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.7556e059.svg";
export { ForwardRef as ReactComponent };